import { Injectable } from '@angular/core';
import { FontFamily } from '../models/df-font-family';
import { FontsService, Font } from '../../../../../../services/fonts.service';

@Injectable()
export class FontFamilyService {
	constructor(private fontsService: FontsService) {}

	getFonts(): Array<FontFamily> {
		let fonts: Array<FontFamily>;

		fonts = this.fontsService.getFonts().map((font) => {
			return new FontFamily({
				fontValue: font.url,
				fontLabel: font.label
			});
		});
		return fonts;
	}
}
